<template>
  <div>
    <section id="public-invoice-information">
      <div class="container">
        <div class="invoice-wrapper">
          <div class="a4-size-button">
            <button
              type="button"
              class="btn btn-outline-primary mb-20"
              @click.prevent="exportInvoiceToPDF()"
            >
              Export PDF
            </button>
          </div>

          <div class="a4-size" ref="invoicePdf">
            <div class="brand-wrapper">
              <div class="brand--title--invoice">
                <h2>Trransfer Technologies Pte Ltd</h2>
                <span>221 Henderson Road,</span>
                <span>#01-05 Henderson Building,</span>
                <span>Singapore 159557</span>
                <span>accounts@trransfer.com</span>
                <span>www.trransfer.com</span>
                <span>Company registration No. 202137384K</span>
              </div>
              <div class="brand--logo--invoice">
                <div class="logo-trr-wrapper">
                  <img
                    src="/static/assets/images/trr-invoice.jpg"
                    alt="trr-logo"
                  />
                </div>
              </div>
            </div>

            <div class="description-wrapper">
              <div class="bill-to-wrapper">
                <label class="label-invoice">BILL TO</label>
                <div
                  class="value-invoice"
                  v-html="formattedDescription(invoiceData.billTo)"
                ></div>
              </div>
              <div class="payment-invoice-wrapper">
                <div class="d-flex gap-5">
                  <label class="label-invoice-inline">NO.</label>
                  <div class="value-invoice-inline">
                    {{ invoiceData.invoiceNumber }}
                  </div>
                </div>
                <div class="d-flex gap-5">
                  <label class="label-invoice-inline">INVOICE DATE</label>
                  <div class="value-invoice-inline">
                    {{ invoiceData.invoiceDate }}
                  </div>
                </div>
                <div class="d-flex gap-5">
                  <label class="label-invoice-inline">PAYMENT ID</label>
                  <div class="value-invoice-inline">
                    {{ invoiceData.paymentId ? invoiceData.paymentId : "-" }}
                  </div>
                </div>
                <div class="d-flex gap-5">
                  <label class="label-invoice-inline">PAYMENT METHOD</label>
                  <div class="value-invoice-inline">
                    {{ invoiceData.paymentMethod }}
                  </div>
                </div>
              </div>
            </div>

            <div class="table-wrapper">
              <table class="table-invoice">
                <thead>
                  <tr>
                    <th>DATE</th>
                    <th>ACTIVITY</th>
                    <th>DESCRIPTION</th>
                    <th>QTY</th>
                    <th class="text-right">RATE</th>
                    <th class="text-right">AMOUNT</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(val, index) in reservations" :key="index">
                    <td>{{ $helper.dateUKFormatted(val.pickUpDate) }}</td>
                    <td>{{ val.name }}</td>
                    <td v-html="formattedDescription(val.description)"></td>
                    <td class="text-center">{{ val.qty }}</td>
                    <td class="text-right" style="min-width: 90px">
                      <div class="d-flex flex-column">
                        <span>
                          {{ val.currency }}
                          {{ $currencyFormat(val.currency, val.amount) }}
                        </span>
                        <span
                          class="local-currency-text"
                          v-if="val.currency !== val.localCurrency"
                        >
                          {{ val.localCurrency }}
                          {{
                            $currencyFormat(val.localCurrency, val.localAmount)
                          }}
                        </span>
                      </div>
                    </td>
                    <td class="text-right" style="min-width: 90px">
                      <div class="d-flex flex-column">
                        <span>
                          {{ val.currency }}
                          {{ $currencyFormat(val.currency, val.totalAmount) }}
                        </span>
                        <span
                          class="local-currency-text"
                          v-if="val.currency !== val.localCurrency"
                        >
                          {{ val.localCurrency }}
                          {{
                            $currencyFormat(
                              val.localCurrency,
                              val.localTotalAmount
                            )
                          }}
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="4" class="text-right">
                      {{
                        !invoiceData.paymentId ||
                        invoiceData.paymentId === "N/A"
                          ? "TOTAL AMOUNT OUTSTANDING"
                          : "TOTAL AMOUNT PAID"
                      }}
                    </td>
                    <td colspan="2" class="text-right">
                      {{ totalAmount.transaksi.currency }}
                      {{
                        $currencyFormat(
                          totalAmount.transaksi.currency,
                          totalAmount.transaksi.value
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="4" class="text-right local-currency-row">
                      TOTAL AMOUNT (LOCAL)
                    </td>
                    <td colspan="2" class="text-right local-currency-row">
                      {{ totalAmount.local.currency }}
                      {{
                        $currencyFormat(
                          totalAmount.local.currency,
                          totalAmount.local.value
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="4" class="text-right local-currency-row">
                      TOTAL AMOUNT ({{ totalAmount.tenant.currency }})
                    </td>
                    <td colspan="2" class="text-right local-currency-row">
                      {{ totalAmount.tenant.currency }}
                      {{
                        $currencyFormat(
                          totalAmount.tenant.currency,
                          totalAmount.tenant.value
                        )
                      }}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Content -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";
import invoiceService from "@/services/shop/invoiceService.js";

export default {
  data() {
    return {
      imageBase64: null,
      invoiceData: {
        companyId: null,
        invoiceDate: null,
        invoiceNumber: null,
        billTo: null,
        paymentId: null,
        paymentMethod: null,
      },
      totalAmount: {
        transaksi: {},
        local: {},
        tenant: {},
      },
      reservations: [],
      isLoading: false,
      msg: "Please wait",
    };
  },
  computed: {
    grandTotal: function () {
      return this.reservations.reduce((sum, item) => sum + item.totalAmount, 0);
    },
  },
  async created() {
    this.$helper.scrollTop();
    this.isLoading = true;
  },
  mounted() {
    this.getPublicInvoice();
  },
  methods: {
    async getPublicInvoice() {
      try {
        this.isLoading = true;
        const params = `tenantId=${this.$route.query.tid}&username=${this.$route.query.u}`;
        const response = await invoiceService.getPublicRetrieveInvoice(
          this.$route.params.invoice_id,
          params
        );

        if (response.isSuccess) {
          this.invoiceData = {
            companyId: response.data.companyId,
            invoiceNumber: response.data.number,
            invoiceDate: this.$helper.dateUKFormatted(
              response.data.invoiceDate
            ),
            billTo: response.data.billTo,
            paymentId: response.data.paymentId,
            paymentMethod: response.data.paymentMethod,
          };
          this.totalAmount = {
            transaksi: response.data.txnAmount,
            local: response.data.localAmount,
            tenant: response.data.tenantAmount,
          };
          this.reservations = response.data.items.flatMap((item) => {
            return item.details.map((val) => {
              return {
                reservationCode: item.reservationCode,
                pickUpDate: item.pickUpDate,
                // details
                description: val.description,
                name: val.name,
                currency: val.txnAmount.currency,
                amount: val.txnAmount.value,
                totalAmount: val.txnAmount.total,
                localAmount: val.localAmount.value,
                localCurrency: val.localAmount.currency,
                localTotalAmount: val.localAmount.total,
                qty: val.qty,
              };
            });
          });
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    formattedDescription(value) {
      return value.replace(/\n/g, "<br>");
    },
    async exportInvoiceToPDF() {
      try {
        this.isLoading = true;

        const element = this.$refs.invoicePdf;
        const opt = {
          margin: 0, // inch
          filename: `${this.invoiceData.invoiceNumber}.pdf`,
          image: { type: "jpeg", quality: 1 },
          html2canvas: { scale: 2, useCORS: true, allowTaint: true },
          jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
          // pagebreak: { mode: ["avoid-all", "css", "legacy"] },
        };

        await html2pdf().set(opt).from(element).save();
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style scoped>
.invoice-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(max-content + 50px);
  margin-top: 100px;
  padding-bottom: 50px;
}

.brand-wrapper {
  display: flex;
  width: 100%;
}

.brand--title--invoice {
  display: flex;
  flex-direction: column;
  width: 50%;
}

.brand--title--invoice h2 {
  font-size: 15px;
  font-weight: 800;
  color: #000;
}

.brand--title--invoice span {
  font-size: 11px;
  font-weight: normal;
}

.brand--logo--invoice {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 50%;
}

.brand--logo--invoice .logo-trr-wrapper img {
  object-fit: contain;
  max-width: 180px;
}

.table-wrapper {
  width: 100%;
  margin-top: 20px;
}

table.table-invoice {
  border-collapse: collapse;
  margin: 25px 0;
  font-size: 0.9em;
  width: 100%;
  overflow: hidden;
}

.table-invoice thead {
  background: rgba(79, 184, 72, 0.2);
  color: #4fb848;
  width: 100%;
}

.table-invoice thead th,
.table-invoice tbody td,
.table-invoice tfoot td {
  padding: 15px 10px;
  font-size: 11px;
}

.table-invoice tfoot tr:first-child {
  border-top: 2px dotted #ddd;
}

.table-invoice tfoot td {
  padding: 1px 10px;
}

.table-invoice tfoot tr td {
  font-size: 15px;
  font-weight: 800;
  color: #000;
}

.table-invoice tfoot tr td.local-currency-row {
  font-size: 14px;
  font-weight: 600;
  color: #ccc;
}

.description-wrapper {
  display: flex;
  width: 100%;
  margin-top: 30px;
}

.bill-to-wrapper {
  display: flex;
  flex-direction: column;
  vertical-align: top;
  width: 50%;
}

.label-invoice {
  font-size: 11px;
  font-weight: 800;
  color: #cccccc;
}

.value-invoice {
  font-size: 11px;
}

.label-invoice-inline {
  display: flex;
  justify-content: flex-end;
  font-size: 11px;
  font-weight: 800;
  color: #cccccc;
  min-width: 90px;
}

.value-invoice-inline {
  font-size: 11px;
  width: 150px;
  text-align: right;
}

.payment-invoice-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 5px;
  width: 50%;
  vertical-align: top;
}

.payment-invoice-wrapper table tr {
  height: 30px;
}

.payment-invoice-wrapper .label-table {
  font-size: 11px;
  font-weight: 800;
  color: #cccccc;
  width: max-content;
  white-space: nowrap;
  vertical-align: top;
}

.payment-invoice-wrapper .value-table {
  font-size: 11px;
  vertical-align: top;
}

.payment-invoice {
  display: flex;
}

.payment-invoice label.label-invoice {
  width: 130px;
}

.a4-size-button {
  width: 210mm;
  margin: auto;
  background: white;
  display: flex;
  justify-content: space-between;
}

.a4-size {
  width: 210mm;
  height: calc(max-content + 20px);
  margin: auto;
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  padding: 10mm;
}

table td,
table th {
  vertical-align: top;
}
/* End */
</style>



// WEBPACK FOOTER //
// src/components/invoice/PublicInvoiceInformation.vue